module.exports = __webpack_public_path__ + "static/media/funJams.b5df8d99.png";